import axios from '../api/axiosInstance';

export const fetchCategories = (params) => {
  return axios.get('/shop-categories', { params });
};

export const createCategory = (data) => {
  return axios.post('/shop-categories', data);
};

export const updateCategory = (id, data) => {
  return axios.put(`/shop-categories/${id}`, data);
};

export const updateCategoryStatus = (id, status) => {
  return axios.patch(`/shop-categories/${id}/status`, { status });
};

export const deleteCategory = (id) => {
  return axios.delete(`/shop-categories/${id}`);
};

